import script from "./JobsDoneContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./JobsDoneContainer.vue?vue&type=script&setup=true&lang=js"

import "../styles/_jobsDone.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__